import { useState, useCallback, useMemo, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { Login } from "./Login.component";
import { login } from "../../api/auth";

export const LoginContainer = () => {
  const navigate = useNavigate();
  const [searchparams] = useSearchParams();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const loginUser = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await login(username, password);
      console.log("[login] res:", res);

      // backend renvoie { ok, statusCode, message, data:{ token } }
      const token = res?.data?.data?.token ?? res?.data?.token;

      if (res?.ok && typeof token === "string" && token.length > 0) {
        localStorage.setItem("token", token);
        navigate("/", { replace: true });            // ⬅️ retour sûr vers la Home/Dashboard
      } else {
        alert(res?.message || "Wrong username or/and password");
      }
    } catch (err: any) {
      console.error("[login] error:", err);
      alert(err?.message || "Erreur de connexion. Réessayez.");
    } finally {
      setLoading(false);
    }
  };

  const handleChangeUsername = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) =>
      setUsername(e.target.value),
    []
  );
  const handleChangePwd = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) =>
      setPassword(e.target.value),
    []
  );
  const title = useMemo(() => (loading ? "Chargement ..." : "Connexion"), [loading]);

  useEffect(() => {
    const usernameParams = searchparams.get("username");
    if (usernameParams) setUsername(usernameParams);
  }, [searchparams]);

  return (
    <Login
      username={username}
      handleChangeUsername={handleChangeUsername}
      password={password}
      handleChangePwd={handleChangePwd}
      handleSubmit={loginUser}
      loading={loading}
      title={title}
    />
  );
};